import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "react-bulma-components";
import { Pagination } from "react-bulma-components";
import { Heading } from "react-bulma-components";
import { Table } from "react-bulma-components";
import { getVehiclesData } from "../../state/selectors";
import Spinner from "react-spinner-material";
import { useVehiclesData } from "../../hooks/useVehiclesData";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import CourtesyCarRow from "./CourtesyCarRow";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";

function CourtesyCars({ endpoint, data, filters, setFilters}) {

  const filter = (vehicle) =>{
    return vehicle.company_vehicle
  }

  const headings = [
      {
          label: "Department",
          field: "department",
          labelField: "department__name"
      },
      {
          label: "Registration"
      },
      {
          label: "Make"
      },
      {
          label: "Model"
      },
      {
          label: "Location"
      }
  ]

  return (
    <Box>
      <Heading size={5}>Company Vehicles</Heading>
      <Table>
        <thead>
          <tr className={"small-row-black"}>
            {headings.map(heading => {
                if (!heading.field) {
                  return <th key={heading.label} className={heading.className || ""}>{heading.label}</th>;
                }
                if (heading.blank) {
                  return (
                    <FilterBlankHeading
                      key={heading.label}
                      heading={heading}
                      setFilters={f => {
                        setFilters(f);
                      }}
                      filters={filters}
                      className={heading.className}
                      thClass={heading.thClass}
                    />
                  );
                }
                return (
                  <FilterHeading
                    key={heading.label}
                    heading={heading}
                    setFilters={f => {
                      setFilters(f);
                    }}
                    filters={filters}
                    options={data.filter_list[heading.field]}
                    className={heading.className}
                    thClass={heading.thClass}
                  />
                );
              })}
          </tr>
        </thead>
        <tbody>
          {data.results.filter(filter).map((value, index) => (
            <CourtesyCarRow
              key={value.id}
              value={value}
              index={index}
              endpoint={endpoint}
            />
          ))}
        </tbody>
      </Table>
    </Box>
  );
}

export default CourtesyCars;
